export default function isUnitMetric(unit: string): boolean {
  return ["m", "km"].indexOf(unit) > -1;
}
